import React from 'react';
import classNames from 'classnames';

interface RecuiterCustomCardProps {
	status: string;
	imageSrc: string;
	description: string;
	onClick: () => void;
	disabled: boolean;
	pending?: string;
	// selected: boolean;
	// badge?: string;
	// onBack?: () => void;
}
const RecuiterCustomCard: React.FC<RecuiterCustomCardProps> = ({
	status,
	imageSrc,
	description,
	onClick,
	disabled,
	pending,
}) => {
	return (
		<button
			onClick={onClick}
			disabled={disabled}
			className={classNames(
				'relative w-[280px] flex flex-row flex-shrink-0 py-[17px] mt-2 md:mt-0 rounded-[8px] border border-[#EBEBF0] bg-[#FFF]',
				{
					'cursor-not-allowed': disabled,
					'cursor-pointer': !disabled,
				},
			)}
		>
			<div className="flex justify-center items-center w-[60px] h-[60px]">
				<img src={imageSrc} alt={status} />
			</div>
			<div className="pt-2">
				<h1 className="text-[#1C1C28] font-inter text-left text-[14px] font-[600] leading-[20px]">{status}</h1>
				<p className="text-[#555770] font-inter text-left text-[12px] font-[400] leading-[16px]">{description}</p>
			</div>

			{pending && (
				<div className="absolute top-[10%] left-[64%] flex justify-center items-center px-[8px] rounded-[20px] bg-[#FDED72]">
					<span className="text-center text-[#555770] text-[12px] font-[500] leading-[18px] font-inter">{pending}</span>
				</div>
			)}
		</button>
	);
};

export default RecuiterCustomCard;
